/**
 * Uniquifies the array (array of objects) with respect to referenced key.
 * @param {T[]} defaultList - array of object which is going to be uniquified.
 * @param {string} referenceKeyToBeUniquified - reference key for uniquification operation.
 */
function uniquifyArrayOfObjects<T>(defaultList: T[], referenceKeyToBeUniquified: keyof T): T[] {
    const checkOccurrenceMap = new Map();

    return defaultList.filter(item => {
        const value = item[referenceKeyToBeUniquified];

        if (!checkOccurrenceMap.has(value)) {
            checkOccurrenceMap.set(value, true);
        }

        if (checkOccurrenceMap.get(value)) {
            checkOccurrenceMap.set(value, false);

            return true;
        }

        return false;
    });
}

export default uniquifyArrayOfObjects;
